// import React, { useState } from "react";

// import { Link, Routes, Route, useParams } from "react-router-dom";
// import "./Projects.css";

// // ================== Dynamic Project Data ==================
// const projects = [
//   {
//     id: 1,
//     category: "MERN Stack",
//     title: "AR/VR Powered E-Commerce Website",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
//     name: "Furnishlub E-Commerce",
//     details:
//       "Designed and deployed a full-stack AR/VR web application using MERN stack, integrated with Three.js and WebXR for immersive 3D shopping experience.",
//     time: "Dec 2024 - Feb 2025",
//     tools: ["MongoDB", "Express", "React", "Node.js", "Three.js", "WebXR"],
//     github: "https://github.com/HardikParmar75/workspace-furntech",
//   },
//   {
//     id: 2,
//     category: "Flutter",
//     title: "Shree Hanumanji App",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
//     name: "Shree Hanumanji",
//     details:
//       "Developed a multilingual mobile app with 700+ shloks, implemented audio playback, chapter-wise navigation, and offline accessibility.",
//     time: "Jan 2025 – July 2025",
//     tools: ["Flutter", "Dart", "Audio Players", "Local Storage"],
//     github: "https://github.com/Ritesh151/hanuman-app",
//   },
//   {
//     id: 3,
//     category: "Flutter",
//     title: "Srimad Bhagvat Geeta App",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
//     name: "Srimad Bhagvat Geeta",
//     details:
//       "A comprehensive scripture app featuring all 700 verses with translations, audio recitations, and bookmark functionality.",
//     time: "Mar 2025 - May 2025",
//     tools: ["Flutter", "Dart", "SQLite", "Audio Management"],
//     github: "https://github.com/Ritesh151/Srimad-Bhagvat-Geeta",
//   },
//   {
//     id: 4,
//     category: "Flutter",
//     title: "ExpenseEase App",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
//     name: "ExpenseEase",
//     details:
//       "A personal finance management app that helps users track expenses, set budgets, and visualize spending patterns.",
//     time: "Apr 2025 - Jun 2025",
//     tools: ["Flutter", "Dart", "Firebase", "Charts", "Local Authentication"],
//     github: "https://github.com/Ritesh151/",
//   },
//   {
//     id: 5,
//     category: "React JS",
//     title: "The GR Group Website",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
//     name: "The GR Group",
//     details:
//       "A professional business website built for a client with modern UI, responsive design, and contact forms.",
//     time: "Feb 2025 - Mar 2025",
//     tools: ["React", "CSS", "JavaScript", "Form Handling"],
//     github: "https://github.com/Ritesh151/thegrgroup",
//     liveDemo: "https://thegrgroup.netlify.app/",
//   },
//   {
//     id: 6,
//     category: "React JS",
//     title: "RiteshPortfolio Website",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
//     name: "RiteshPortfolio",
//     details:
//       "A personal portfolio website showcasing skills, projects, and experience with modern design and animations.",
//     time: "Jan 2025 - Feb 2025",
//     tools: ["React", "CSS", "Framer Motion", "Responsive Design"],
//     github: "https://github.com/Ritesh151/Flutter_Protfolio",
//     liveDemo: "#",
//   },
//   {
//     id: 7,
//     category: "React JS",
//     title: "Invoice Generator",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
//     name: "Invoice Generator",
//     details:
//       "A tool for creating professional invoices with customizable templates, calculations, and export functionality.",
//     time: "Mar 2025 - Apr 2025",
//     tools: ["React", "JavaScript", "PDF Generation", "UI Components"],
//     github: "https://github.com/Ritesh151/",
//   },
//   {
//     id: 8,
//     category: "Data Science",
//     title: "BlinkIt Data Analysis",
//     logo: "https://cdn.worldvectorlogo.com/logos/tableau-software.svg",
//     name: "BlinkIt MySQL Project",
//     details:
//       "Performed complex SQL queries to analyze BlinkIt's business data, extracting insights about sales patterns and customer behavior.",
//     time: "May 2025 - Jun 2025",
//     tools: ["Tableau", "MySQL", "Data Analysis", "Complex Queries", "Business Intelligence"],
//     github: "https://github.com/Ritesh151/",
//   },
//   {
//     id: 9,
//     category: "Data Science",
//     title: "AirBnB Data Analysis",
//     logo: "https://cdn.worldvectorlogo.com/logos/tableau-software.svg",
//     name: "AirBnB MySQL Project",
//     details:
//       "Analyzed AirBnB dataset using advanced SQL queries to identify trends in pricing, occupancy rates, and seasonal patterns.",
//     time: "Jun 2025 - Jul 2025",
//     tools: ["Tableau", "MySQL", "Data Visualization", "Trend Analysis", "SQL Optimization"],
//     github: "https://github.com/Ritesh151/",
//   },
//   {
//     id: 10,
//     category: "Data Science",
//     title: "AI Chatbot",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
//     name: "OpenAI API Chatbot",
//     details:
//       "Built an AI-powered chatbot using OpenAI's API with natural language processing capabilities and contextual responses.",
//     time: "Jul 2025 - Aug 2025",
//     tools: ["Python", "OpenAI API", "Natural Language Processing", "API Integration"],
//     github: "https://github.com/Ritesh151",
//   },
//   {
//     id: 11,
//     category: "Flutter",
//     title: "To-Do List App",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
//     name: "To-Do List Application",
//     details:
//       "A productivity app with task management, categories, reminders, and synchronization across devices.",
//     time: "Nov 2024 - Dec 2024",
//     tools: ["Flutter", "Dart", "Local Storage", "Notifications"],
//     github: "https://github.com/Ritesh151/",
//   },
//   {
//     id: 12,
//     category: "Flutter",
//     title: "Language Translator",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
//     name: "Language Translator App",
//     details:
//       "A mobile translation app supporting multiple languages with text-to-speech functionality and phrasebook feature.",
//     time: "Oct 2024 - Nov 2024",
//     tools: ["Flutter", "Translation API", "Text-to-Speech", "Offline Capabilities"],
//     github: "https://github.com/Ritesh151/",
//   },
//   {
//     id: 13,
//     category: "Flutter",
//     title: "Currency Converter",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
//     name: "Currency Converter App",
//     details:
//       "Real-time currency conversion app with updated exchange rates, historical charts, and favorite currencies.",
//     time: "Sep 2024 - Oct 2024",
//     tools: ["Flutter", "API Integration", "Charts", "Exchange Rates"],
//     github: "https://github.com/Ritesh151/",
//   },
//   {
//     id: 14,
//     category: "Flutter",
//     title: "Weather Application",
//     logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
//     name: "Weather App",
//     details:
//       "A weather forecasting app with location-based forecasts, severe weather alerts, and interactive maps.",
//     time: "Aug 2024 - Sep 2024",
//     tools: ["Flutter", "Weather API", "Geolocation", "Data Visualization"],
//     github: "https://github.com/Ritesh151/",
//   },
// ];

// // ================== Responsive Project List Component ==================
// const ProjectList = () => {
//   const [selectedCategory, setSelectedCategory] = useState("All");

//   // Get unique categories from projects
//   const categories = ["All", ...new Set(projects.map(project => project.category))];

//   const filteredProjects =
//     selectedCategory === "All"
//       ? projects
//       : projects.filter((p) => p.category === selectedCategory);

//   return (
//     <div className="projects-container" style={{
//       maxWidth: "1200px",
//       margin: "0 auto",
//       padding: "1rem",
//       boxSizing: "border-box"
//     }}>
//       <h1 className="projects-title" style={{
//         fontSize: "2rem",
//         textAlign: "center",
//         marginBottom: "1.5rem"
//       }}>📊 My Projects</h1>

//       {/* Category Filter */}
//       <div
//         className="category-filter"
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: "0.5rem",
//           justifyContent: "center",
//           marginBottom: "1.5rem"
//         }}
//       >
//         {categories.map((cat) => (
//           <button
//             key={cat}
//             className={`filter-btn ${selectedCategory === cat ? "active" : ""}`}
//             style={{
//               padding: "0.5rem 1rem",
//               borderRadius: "20px",
//               border: "none",
//               background: selectedCategory === cat ? "#007bff" : "#f0f0f0",
//               color: selectedCategory === cat ? "#fff" : "#333",
//               fontWeight: "bold",
//               fontSize: "1rem",
//               cursor: "pointer",
//               transition: "background 0.2s"
//             }}
//             onClick={() => setSelectedCategory(cat)}
//           >
//             {cat}
//           </button>
//         ))}
//       </div>

//       {/* Project Cards */}
//       <div
//         className="projects-grid"
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
//           gap: "1.2rem",
//         }}
//       >
//         {filteredProjects.map((project) => (
//           <Link
//             key={project.id}
//             to={`/projects/${project.id}`}
//             className="project-card"
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               background: "#fff",
//               borderRadius: "16px",
//               boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
//               padding: "1.2rem",
//               textDecoration: "none",
//               color: "#222",
//               transition: "transform 0.15s, box-shadow 0.15s",
//               minHeight: "260px",
//               cursor: "pointer"
//             }}
//           >
//             <div className="project-image" style={{
//               width: "60px",
//               height: "60px",
//               marginBottom: "1rem",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center"
//             }}>
//               <img
//                 src={project.logo}
//                 alt={project.title}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "contain"
//                 }}
//               />
//             </div>
//             <div className="project-content" style={{
//               textAlign: "center",
//               flex: 1,
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center"
//             }}>
//               <h3 style={{
//                 fontSize: "1.1rem",
//                 fontWeight: "bold",
//                 margin: "0 0 0.5rem 0"
//               }}>{project.title}</h3>
//               <p className="category" style={{
//                 fontSize: "0.95rem",
//                 color: "#007bff",
//                 margin: "0 0 0.3rem 0"
//               }}>{project.category}</p>
//               <p className="time" style={{
//                 fontSize: "0.85rem",
//                 color: "#888",
//                 margin: 0
//               }}>{project.time}</p>
//             </div>
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

// // ================== Responsive Single Project Component ==================
// const SingleProject = () => {
//   const { id } = useParams();
//   const project = projects.find((p) => p.id === parseInt(id));

//   if (!project) {
//     return <h2 className="not-found" style={{
//       textAlign: "center",
//       marginTop: "2rem",
//       fontSize: "1.5rem"
//     }}>Project Not Found</h2>;
//   }

//   // If github link is missing, fallback to profile
//   const githubLink = project.github
//     ? project.github
//     : "https://github.com/Ritesh151";

//   return (
//     <div className="single-project" style={{
//       maxWidth: "700px",
//       margin: "0 auto",
//       padding: "1rem",
//       boxSizing: "border-box"
//     }}>
//       <Link
//         to="/projects"
//         className="back-btn"
//         style={{
//           display: "inline-block",
//           marginBottom: "1.2rem",
//           color: "#007bff",
//           textDecoration: "none",
//           fontWeight: "bold",
//           fontSize: "1rem"
//         }}
//       >
//         ← Back to Projects
//       </Link>
//       <div className="project-details" style={{
//         background: "#fff",
//         borderRadius: "16px",
//         boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
//         padding: "1.5rem",
//         display: "flex",
//         flexDirection: "column",
//         gap: "1.2rem"
//       }}>
//         <div className="project-header" style={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           gap: "0.7rem"
//         }}>
//           <img
//             src={project.logo}
//             alt={project.title}
//             style={{
//               width: "70px",
//               height: "70px",
//               objectFit: "contain"
//             }}
//           />
//           <h2 style={{
//             fontSize: "1.5rem",
//             margin: 0,
//             textAlign: "center"
//           }}>{project.name}</h2>
//           <p className="project-category" style={{
//             color: "#007bff",
//             fontWeight: "bold",
//             fontSize: "1rem",
//             margin: 0
//           }}>{project.category} Project</p>
//         </div>
//         <div className="project-info" style={{
//           fontSize: "1rem",
//           display: "flex",
//           flexDirection: "column",
//           gap: "0.7rem"
//         }}>
//           <p>
//             <strong>Project Title:</strong> {project.title}
//           </p>
//           <p>
//             <strong>Details:</strong> {project.details}
//           </p>
//           <p>
//             <strong>Timeline:</strong> {project.time}
//           </p>
//           <p>
//             <strong>Tools & Technologies:</strong>
//           </p>
//           <div className="tools-list" style={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: "0.5rem",
//             marginBottom: "0.5rem"
//           }}>
//             {project.tools.map((tool, index) => (
//               <span
//                 key={index}
//                 className="tool-tag"
//                 style={{
//                   background: "#f0f0f0",
//                   color: "#333",
//                   borderRadius: "12px",
//                   padding: "0.3rem 0.8rem",
//                   fontSize: "0.95rem",
//                   fontWeight: "500"
//                 }}
//               >
//                 {tool}
//               </span>
//             ))}
//           </div>
//           {(githubLink || project.liveDemo) && (
//             <div className="project-links" style={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: "0.7rem",
//               marginTop: "0.5rem"
//             }}>
//               {githubLink && (
//                 <a
//                   href={githubLink}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="project-link"
//                   style={{
//                     background: "#222",
//                     color: "#fff",
//                     borderRadius: "8px",
//                     padding: "0.5rem 1.2rem",
//                     textDecoration: "none",
//                     fontWeight: "bold",
//                     fontSize: "1rem",
//                     transition: "background 0.2s"
//                   }}
//                 >
//                   View on GitHub
//                 </a>
//               )}
//               {project.liveDemo && (
//                 <a
//                   href={project.liveDemo}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="project-link"
//                   style={{
//                     background: "#007bff",
//                     color: "#fff",
//                     borderRadius: "8px",
//                     padding: "0.5rem 1.2rem",
//                     textDecoration: "none",
//                     fontWeight: "bold",
//                     fontSize: "1rem",
//                     transition: "background 0.2s"
//                   }}
//                 >
//                   Live Demo
//                 </a>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // ================== Main Export ==================
// // Responsive: grid and flex layouts, font sizes, paddings, and buttons adapt to mobile
// // For full responsiveness, ensure Projects.css does not override these styles with fixed widths or paddings.
// const Projects = () => {
//   return (
//     <Routes>
//       <Route index element={<ProjectList />} />
//       <Route path=":id" element={<SingleProject />} />
//     </Routes>
//   );
// };

// export default Projects;


import React, { useState } from "react";
import { Link, Routes, Route, useParams } from "react-router-dom";
import "./Projects.css";

// ================== Dynamic Project Data ==================
const projects = [
  {
    id: 1,
    category: "MERN Stack",
    title: "AR/VR Powered E-Commerce Website",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    name: "Furnishlub E-Commerce",
    details:
      "Designed and deployed a full-stack AR/VR web application using MERN stack, integrated with Three.js and WebXR for immersive 3D shopping experience.",
    time: "Dec 2024 - Feb 2025",
    tools: ["MongoDB", "Express", "React", "Node.js", "Three.js", "WebXR"],
    github: "https://github.com/HardikParmar75/workspace-furntech",
  },
  {
    id: 2,
    category: "Flutter",
    title: "Shree Hanumanji App",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    name: "Shree Hanumanji",
    details:
      "Developed a multilingual mobile app with 700+ shloks, implemented audio playback, chapter-wise navigation, and offline accessibility.",
    time: "Jan 2025 – July 2025",
    tools: ["Flutter", "Dart", "Audio Players", "Local Storage"],
    github: "https://github.com/Ritesh151/hanuman-app",
  },
  {
    id: 3,
    category: "Flutter",
    title: "Srimad Bhagvat Geeta App",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    name: "Srimad Bhagvat Geeta",
    details:
      "A comprehensive scripture app featuring all 700 verses with translations, audio recitations, and bookmark functionality.",
    time: "Mar 2025 - May 2025",
    tools: ["Flutter", "Dart", "SQLite", "Audio Management"],
    github: "https://github.com/Ritesh151/Srimad-Bhagvat-Geeta",
  },
  {
    id: 4,
    category: "Flutter",
    title: "ExpenseEase App",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    name: "ExpenseEase",
    details:
      "A personal finance management app that helps users track expenses, set budgets, and visualize spending patterns.",
    time: "Apr 2025 - Jun 2025",
    tools: ["Flutter", "Dart", "Firebase", "Charts", "Local Authentication"],
    github: "https://github.com/Ritesh151/",
  },
  {
    id: 5,
    category: "React JS",
    title: "The GR Group Website",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    name: "The GR Group",
    details:
      "A professional business website built for a client with modern UI, responsive design, and contact forms.",
    time: "Feb 2025 - Mar 2025",
    tools: ["React", "CSS", "JavaScript", "Form Handling"],
    github: "https://github.com/Ritesh151/thegrgroup",
    liveDemo: "https://thegrgroup.netlify.app/",
  },
  {
    id: 6,
    category: "React JS",
    title: "RiteshPortfolio Website",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    name: "RiteshPortfolio",
    details:
      "A personal portfolio website showcasing skills, projects, and experience with modern design and animations.",
    time: "Jan 2025 - Feb 2025",
    tools: ["React", "CSS", "Framer Motion", "Responsive Design"],
    github: "https://github.com/Ritesh151/Flutter_Protfolio",
    liveDemo: "#",
  },
  {
    id: 7,
    category: "React JS",
    title: "Invoice Generator",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    name: "Invoice Generator",
    details:
      "A tool for creating professional invoices with customizable templates, calculations, and export functionality.",
    time: "Mar 2025 - Apr 2025",
    tools: ["React", "JavaScript", "PDF Generation", "UI Components"],
    github: "https://github.com/Ritesh151/",
  },
  {
    id: 8,
    category: "Data Science",
    title: "BlinkIt Data Analysis",
    logo: "https://cdn.worldvectorlogo.com/logos/tableau-software.svg",
    name: "BlinkIt MySQL Project",
    details:
      "Performed complex SQL queries to analyze BlinkIt's business data, extracting insights about sales patterns and customer behavior.",
    time: "May 2025 - Jun 2025",
    tools: ["Tableau", "MySQL", "Data Analysis", "Complex Queries", "Business Intelligence"],
    github: "https://github.com/Ritesh151/",
  },
  {
    id: 9,
    category: "Data Science",
    title: "AirBnB Data Analysis",
    logo: "https://cdn.worldvectorlogo.com/logos/tableau-software.svg",
    name: "AirBnB MySQL Project",
    details:
      "Analyzed AirBnB dataset using advanced SQL queries to identify trends in pricing, occupancy rates, and seasonal patterns.",
    time: "Jun 2025 - Jul 2025",
    tools: ["Tableau", "MySQL", "Data Visualization", "Trend Analysis", "SQL Optimization"],
    github: "https://github.com/Ritesh151/",
  },
  {
    id: 10,
    category: "Data Science",
    title: "AI Chatbot",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    name: "OpenAI API Chatbot",
    details:
      "Built an AI-powered chatbot using OpenAI's API with natural language processing capabilities and contextual responses.",
    time: "Jul 2025 - Aug 2025",
    tools: ["Python", "OpenAI API", "Natural Language Processing", "API Integration"],
    github: "https://github.com/Ritesh151",
  },
  {
    id: 11,
    category: "Flutter",
    title: "To-Do List App",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    name: "To-Do List Application",
    details:
      "A productivity app with task management, categories, reminders, and synchronization across devices.",
    time: "Nov 2024 - Dec 2024",
    tools: ["Flutter", "Dart", "Local Storage", "Notifications"],
    github: "https://github.com/Ritesh151/",
  },
  {
    id: 12,
    category: "Flutter",
    title: "Language Translator",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    name: "Language Translator App",
    details:
      "A mobile translation app supporting multiple languages with text-to-speech functionality and phrasebook feature.",
    time: "Oct 2024 - Nov 2024",
    tools: ["Flutter", "Translation API", "Text-to-Speech", "Offline Capabilities"],
    github: "https://github.com/Ritesh151/",
  },
  {
    id: 13,
    category: "Flutter",
    title: "Currency Converter",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    name: "Currency Converter App",
    details:
      "Real-time currency conversion app with updated exchange rates, historical charts, and favorite currencies.",
    time: "Sep 2024 - Oct 2024",
    tools: ["Flutter", "API Integration", "Charts", "Exchange Rates"],
    github: "https://github.com/Ritesh151/",
  },
  {
    id: 14,
    category: "Flutter",
    title: "Weather Application",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
    name: "Weather App",
    details:
      "A weather forecasting app with location-based forecasts, severe weather alerts, and interactive maps.",
    time: "Aug 2024 - Sep 2024",
    tools: ["Flutter", "Weather API", "Geolocation", "Data Visualization"],
    github: "https://github.com/Ritesh151/",
  },
];

// ================== Responsive Project List Component ==================
const ProjectList = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  // Get unique categories from projects
  const categories = ["All", ...new Set(projects.map(project => project.category))];

  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((p) => p.category === selectedCategory);

  return (
    <div className="projects-container">
      <h1 className="projects-title">📊 My Projects</h1>

      {/* Category Filter */}
      <div className="category-filter">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`filter-btn ${selectedCategory === cat ? "active" : ""}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Project Cards */}
      <div className="projects-grid">
        {filteredProjects.map((project) => (
          <Link
            key={project.id}
            to={`/projects/${project.id}`}
            className="project-card"
          >
            <div className="project-image">
              <img
                src={project.logo}
                alt={project.title}
              />
            </div>
            <div className="project-content">
              <h3>{project.title}</h3>
              <p className="category">{project.category}</p>
              <p className="time">{project.time}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

// ================== Responsive Single Project Component ==================
const SingleProject = () => {
  const { id } = useParams();
  const project = projects.find((p) => p.id === parseInt(id));

  if (!project) {
    return <h2 className="not-found">Project Not Found</h2>;
  }

  // If github link is missing, fallback to profile
  const githubLink = project.github
    ? project.github
    : "https://github.com/Ritesh151";

  return (
    <div className="single-project">
      <Link
        to="/projects"
        className="back-btn"
      >
        ← Back to Projects
      </Link>
      <div className="project-details">
        <div className="project-header">
          <img
            src={project.logo}
            alt={project.title}
          />
          <h2>{project.name}</h2>
          <p className="project-category">{project.category} Project</p>
        </div>
        <div className="project-info">
          <p>
            <strong>Project Title:</strong> {project.title}
          </p>
          <p>
            <strong>Details:</strong> {project.details}
          </p>
          <p>
            <strong>Timeline:</strong> {project.time}
          </p>
          <p>
            <strong>Tools & Technologies:</strong>
          </p>
          <div className="tools-list">
            {project.tools.map((tool, index) => (
              <span
                key={index}
                className="tool-tag"
              >
                {tool}
              </span>
            ))}
          </div>
          {(githubLink || project.liveDemo) && (
            <div className="project-links">
              {githubLink && (
                <a
                  href={githubLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link github-link"
                >
                  View on GitHub
                </a>
              )}
              {project.liveDemo && (
                <a
                  href={project.liveDemo}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link demo-link"
                >
                  Live Demo
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// ================== Main Export ==================
const Projects = () => {
  return (
    <Routes>
      <Route index element={<ProjectList />} />
      <Route path=":id" element={<SingleProject />} />
    </Routes>
  );
};

export default Projects;